/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateSubscriptionRequest,
  FindAllPaginatedParams,
  FindSubscriptionsRequest,
  PaginatedResponseObjectObject,
  SubscriptionDto,
  SubscriptionResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSubscriptionsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-subscriptions-controller
   * @name Create6
   * @request POST:/api/v1/subscriptions
   * @deprecated
   */
  create = (data: CreateSubscriptionRequest, params: RequestParams = {}) =>
    this.http.request<SubscriptionDto, any>({
      path: `/v1/subscriptions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/subscriptions'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags api-subscriptions-controller
   * @name FindAllPaginated
   * @request POST:/api/v1/subscriptions/paged
   */
  findAllPaginated = (
    query: FindAllPaginatedParams,
    data: FindSubscriptionsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PaginatedResponseObjectObject, any>({
      path: `/v1/subscriptions/paged`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static findAllPaginatedPath = '/v1/subscriptions/paged'
  static findAllPaginatedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-subscriptions-controller
   * @name FindPlatformFeeSubscription
   * @request GET:/api/v1/subscriptions/platform-fee
   */
  findPlatformFeeSubscription = (params: RequestParams = {}) =>
    this.http.request<SubscriptionResponse, any>({
      path: `/v1/subscriptions/platform-fee`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findPlatformFeeSubscriptionPath = '/v1/subscriptions/platform-fee'
  static findPlatformFeeSubscriptionMethod = 'GET'
}
